/**
 * @file 회의실 예약 API
 * 회의공간(마스터) 관리 + 예약 CRUD + 캘린더·가용성 조회.
 */
import { api } from "../../../util/api";

const API_BASE = process.env.REACT_APP_API_BASE_URL;
const B = `${API_BASE}/meeting-rooms`;

export const meetingRoomApi = {
    // ─── 회의공간(마스터) ────────────────────────────────────────
    getRooms:   (includeInactive = false) => api.get(B, { includeInactive }),
    createRoom: (data)     => api.post(B, data),
    updateRoom: (id, data) => api.put(`${B}/${id}`, data),
    deleteRoom: (id)       => api.delete(`${B}/${id}`),

    // ─── 참조 데이터 (부서·현재 사용자) ──────────────────────────
    getDepartments: () => api.get(`${API_BASE}/employees/departments`),
    getMe:          () => api.get(`${API_BASE}/employees/me`),

    // ─── 예약 ────────────────────────────────────────────────────
    // 월간 캘린더와 하루 시간표가 같은 기간 조회를 쓴다 (from~to, 날짜).
    getReservations: (from, to) => api.get(`${B}/reservations`, { from, to }),
    getReservation:  (id)       => api.get(`${B}/reservations/${id}`),
    getAvailability: (roomId, startAt, endAt, excludeId) =>
        api.get(`${B}/reservations/availability`,
            { roomId, startAt, endAt, ...(excludeId ? { excludeId } : {}) }),
    createReservation: (data)     => api.post(`${B}/reservations`, data),
    updateReservation: (id, data) => api.put(`${B}/reservations/${id}`, data),
    deleteReservation: (id)       => api.delete(`${B}/reservations/${id}`),
};
